import { NavLink } from "react-router-dom";
import SocialLinks from "../SocialLinks/SocialLinks";
import MainMenu from "../MainMenu/MainMenu";
import styles from "./Header.module.css";

const Header = () => (
  <header>
    <SocialLinks />
    <NavLink to="/" className={styles.logo}>
      Samantha Olguin
    </NavLink>
    <MainMenu />
  </header>
);

export default Header;
